<template>
<div class="app">
    <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>{{ $t('Calendar') }} </v-toolbar-title>

                </v-toolbar>
            </v-flex>
        </v-layout>
    </v-card>

    <div class='demo-app'>
        <div class='demo-app-main'>
            <FullCalendar class='demo-app-calendar' ref="fullCalendar" :options='calendarOptions'>
                <template v-slot:eventContent='arg'>
                    <span class="pa-1">
                        <v-icon color="blue" v-if="arg.event.extendedProps.Provider == 'ticket'">flight</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 1">hotel</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 2">rv_hookup</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 3">restaurant</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 4">local_see</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 5">departure_board</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 6">emoji_people</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 7">house</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 8">flight_takeoff</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 9">directions_boat</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 10">category</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 11">style</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 12">tour</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 13">meeting_room&</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 14">verified_user</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 15">directions_boat</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 16">golf_course</v-icon>
                    </span>
                    <span v-if="arg.event.backgroundColor == 'purple'" class="purple darken-2 white--text pa-1">{{ arg.event.title }}</span>
                    <span v-if="arg.event.backgroundColor == 'green'" class="green darken-2 white--text pa-1 ">{{ arg.event.title }}</span>
                </template>
            </FullCalendar>
        </div>
    </div>

    <v-dialog v-model="coperdetay" v-if="coperdetay" scrollable="" persistent="" max-width="900px">
        <v-card>
            <v-card-title>{{ $t('Coper-List') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap="">
                    <v-flex v-if="coperOtel" xs12 sm12 md12>
                        <v-data-table :headers="headercoperOtel" :rows-per-page-items="[20,100]" :items="coperOtelList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Konum }}</td>
                                    <td class="text-xs-left">{{ props.item.OdaTipi}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperArac" xs12 sm12 md12>
                        <v-data-table :headers="headercoperArac" :rows-per-page-items="[20,100]" :items="coperAracList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.AracTip}}</td>
                                    <td class="text-xs-left">{{ props.item.Nereden }}</td>
                                    <td class="text-xs-left">{{ props.item.Nereye}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperAll" xs12 sm12 md12>
                        <v-data-table :headers="headercoperAll" :rows-per-page-items="[20,100]" :items="coperAllList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperDiger" xs12 sm12 md12>
                        <v-data-table :headers="headercoperDiger" :rows-per-page-items="[20,100]" :items="coperDigerList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Aktivite}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperRentCikis" xs12 sm12 md12>
                        <v-data-table :headers="headercoperRentCikis" :rows-per-page-items="[20,100]" :items="coperRentCikisList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.TeslimSaati}}</td>
                                    <td class="text-xs-left">{{ props.item.TeslimYeri}}</td>
                                    <td class="text-xs-left">{{ props.item.AracTipi}}</td>
                                    <td class="text-xs-left">{{ props.item.Arac}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperRentGiris" xs12 sm12 md12>
                        <v-data-table :headers="headercoperRentGiris" :rows-per-page-items="[20,100]" :items="coperRentGirisList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.AlinisSaati}}</td>
                                    <td class="text-xs-left">{{ props.item.AlinisYeri}}</td>
                                    <td class="text-xs-left">{{ props.item.AracTipi}}</td>
                                    <td class="text-xs-left">{{ props.item.Arac}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperTur" xs12 sm12 md12>
                        <v-data-table :headers="headercoperTur" :rows-per-page-items="[20,100]" :items="coperTurList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Saat}}</td>
                                    <td class="text-xs-left">{{ props.item.BulusmaYeri}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperGemi" xs12 sm12 md12>
                        <v-data-table :headers="headercoperGemi" :rows-per-page-items="[20,100]" :items="coperGemiList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Konum }}</td>
                                    <td class="text-xs-left">{{ props.item.OdaTipi}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperSigorta" xs12 sm12 md12>
                        <v-data-table :headers="headercoperSigorta" :rows-per-page-items="[20,100]" :items="coperSigortaList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.BasTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.BitTarih | dateformat }}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperVizeGiris" xs12 sm12 md12>
                        <v-data-table :headers="headercoperVizeGiris" :rows-per-page-items="[20,100]" :items="coperVizeGirisList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.VizeTip }}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperVizeCikis" xs12 sm12 md12>
                        <v-data-table :headers="headercoperVizeCikis" :rows-per-page-items="[20,100]" :items="coperVizeCikisList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.VizeTip}}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="coperdetay=false">{{$t("cancel_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="ticketdetay" v-if="ticketdetay" scrollable="" persistent="" max-width="900px">
        <v-card>
            <v-card-title>{{ $t('Flight-List') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap="">
                    <v-flex xs12 sm12 md12>
                        <v-data-table :headers="headerticket" :rows-per-page-items="[20,100]" :items="ticketList">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{props.item.HavayoluKodu}}</td>
                                    <td class="text-xs-left">{{ props.item.KalkisParkur }}</td>
                                    <td class="text-xs-left">{{ props.item.VarisParkur }}</td>
                                    <td class="text-xs-left">{{ props.item.UcusSaat }}</td>
                                    <td class="text-xs-left">{{ props.item.UcusTarihi | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.YolcuAdi }}</td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="git(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="ticketdetay=false">{{$t("cancel_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all';
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tool from "../coper/tools"
import tarihim from "@/components/app/customcomp/tarihim.vue"

export default {
    components: {
        tarihim,
        FullCalendar // make the <FullCalendar> tag available
    },
    data: function () {
        return {
            headercoperVizeCikis: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Type'),
                    value: "vizeTip",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperVizeGiris: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Type'),
                    value: "vizeTip",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperSigorta: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Starting-Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Finishing-Date'),
                    value: "bitTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperGemi: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Location'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Room-Type'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperTur: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Hour'),
                    value: "saat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Meeting-Place'),
                    value: "bulusmayeri",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperRentGiris: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Delivery-Time'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Delivery-Place'),
                    value: "teslimyeri",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "aractipi",
                    width: "5%",
                    align: "left"
                }, {
                    text: this.$t('Vehicle'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperRentCikis: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Time'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Place'),
                    value: "teslimyeri",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "aractipi",
                    width: "5%",
                    align: "left"
                }, {
                    text: this.$t('Vehicle'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperDiger: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Acitivity'),
                    value: "aktivite",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperAll: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperArac: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Place'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Departure-Place'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperOtel: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Hotel-Name'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Location'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Room-Type'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headerticket: [{
                    text: this.$t('Airline'),
                    value: "Havayolu",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Departure-Route'),
                    value: "KalkisParkur",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Arrival-Route'),
                    value: "VarisParkur",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Flight-Time'),
                    value: "UcusSaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Flight-Date'),
                    value: "UcusTarihi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Passenger'),
                    value: "YolcuAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "Detay",
                    width: "5%",
                    align: "right"
                }
            ],
            CalendarInput: {
                StartDate: null,
                EndDate: null
            },
            calendarEvents: [],
            VizeRandevu: false,
            TurBulusma: false,
            validform: true,
            takvimekle: false,
            coperdetay: false,
            ticketdetay: false,
            text1: null,
            coperVizeCikisList: [],
            coperVizeGirisList: [],
            coperSigortaList: [],
            coperGemiList: [],
            ticketList: [],
            coperOtelList: [],
            coperAracList: [],
            coperAllList: [],
            coperDigerList: [],
            coperRentCikisList: [],
            coperRentGirisList: [],
            coperTurList: [],
            coperVizeGiris: false,
            coperVizeCikis: false,
            coperSigorta: false,
            coperGemi: false,
            coperRentGiris: false,
            coperRentCikis: false,
            coperDiger: false,
            coperAll: false,
            coperArac: false,
            coperOtel: false,
            coperTur: false,
            detayTarih: null,
            calendarLocale:"en",
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin // needed for dateClick
                ],
                header: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                },
                customButtons: {
                    today: { // this overrides the prev button
                        text: this.$t('Today'),
                        click: () => {
                            this.calendarEvents = []
                            this.calendarOptions.events = this.calendarEvents
                            var date = new Date();
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                      
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.gotoDate(date);

                        }
                    },
                    prev: { // this overrides the prev button
                        text: "PREV",
                        click: () => {
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.prev();

                            var date = new Date(calendarApi.getDate());
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                       
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                        }
                    },
                    next: { // this overrides the next button
                        text: "PREV",
                        click: () => {
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.next();

                            var date = new Date(calendarApi.getDate());
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                        }
                    }
                },
                initialView: 'dayGridMonth',
                initialEvents: null, // alternatively, use the `events` setting to fetch from a feed
                //editable: true,
                //selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                locales: allLocales,
                locale: localStorage.getItem('lang'),
                events: null,
            },
            currentEvents: [],
            MusaitlikInput: {
                DoctorID: 0,
                RequestID: 0,
                StartDate: null,
                EndDate: null,
                Status: null,
            },
            selectedDate: null,
            AvailabilityID: null,
        }
    },
    beforeMount: beforeMount,

    methods: {
        logout() {
            auth.logout()
        },
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },
        handleDateSelect(selectInfo) {
            this.selectedDate = ""
            this.selectedDate = selectInfo.end
            this.takvimekle = true
        },
        handleEventClick(clickInfo) {
            if (clickInfo.event.extendedProps.Provider === "ticket") {
                this.ticketdetay = true

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    CompanyCode: credentials.SirketKodu,
                    StartDate: clickInfo.event.extendedProps.Tarih,
                    EndDate: clickInfo.event.extendedProps.Tarih
                }

                this.$http.post(auth.API_URL + 'api/TicketReport/FlightCalenderList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.ticketList = []
                    this.ticketList = response.body

                }, (response) => {
                    if (response.status === 0) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                    } else {
                        this.text1 = response.statusText
                        this.snackbar = true
                    }
                })

            } else if (clickInfo.event.extendedProps.Provider === "coper") {
                this.coperOtel = false
                this.coperArac = false
                this.coperDiger = false
                this.coperAll = false
                this.VizeRandevu = false
                this.TurBulusma = false
                this.coperRentCikis = false
                this.coperRentGiris = false
                this.coperTur = false
                this.coperGemi = false
                this.coperSigorta = false
                this.coperVizeCikis = false
                this.coperVizeGiris = false
                this.coperVizeGirisList = []
                this.coperVizeCikisList = []
                this.coperSigortaList = []
                this.coperGemiList = []
                this.coperTurList = []
                this.coperRentGirisList = []
                this.coperRentCikisList = []
                this.coperDigerList = []
                this.coperAllList = []
                this.coperOtelList = []
                this.coperAracList = []
                this.coperdetay = true

                let params = {
                    "Tarih1": clickInfo.event.extendedProps.Tarih,
                    "Tarih2": clickInfo.event.extendedProps.Tarih,
                    "SaticiTip": {},
                    "SaticiTipInt": clickInfo.event.extendedProps.SalesType,
                    "Cikis": clickInfo.event.extendedProps.Cikis,
                    "VizeRandevu": clickInfo.event.extendedProps.VizeRandevu,
                    "TurBulusma": clickInfo.event.extendedProps.TurBulusma,
                }
                tool.http_post(this, 'NextCleanderCoper', params).then(
                    response => {
                        if (response.body.Status == true) {
                            for (var i = 0; i < response.body.data.length; i++) {
                                if (response.body.data[i].SaticiTip == 1) {
                                    this.coperOtel = true
                                    this.coperOtelList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Konum: response.body.data[i].Otel_Konum,
                                        OdaTipi: response.body.data[i].Otel_OdaTipi,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 2) {
                                    this.coperArac = true
                                    this.coperAracList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Nereden: response.body.data[i].Transfer_Nerden,
                                        Nereye: response.body.data[i].Transfer_Nereye,
                                        AracTip: response.body.data[i].Transfer_Arac,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 10) {
                                    this.coperDiger = true
                                    this.coperDigerList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Aktivite: response.body.data[i].Diger_Aktivite,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 4) {
                                    this.coperTur = true
                                    this.coperTurList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].Tur_BulusmaTarihi,
                                        Saat: response.body.data[i].Tur_BulusmaSaati.substring(11, 16),
                                        BulusmaYeri: response.body.data[i].Tur_BulusmaYeri,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 5) {
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        this.coperRentCikis = true
                                        this.coperRentCikisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].EndDate,
                                            TeslimYeri: response.body.data[i].RCR_TeslimYeri,
                                            TeslimSaati: response.body.data[i].RCR_TeslimSaat.substring(11, 16),
                                            AracTipi: response.body.data[i].RCR_Kategori,
                                            Arac: response.body.data[i].RCR_Arac,
                                            PNR: response.body.data[i].PNR_No
                                        })
                                    } else {
                                        this.coperRentGiris = true
                                        this.coperRentGirisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].StartDate,
                                            AlinisYeri: response.body.data[i].RCR_AlisYeri,
                                            AlinisSaati: response.body.data[i].RCR_AlisSaat.substring(11, 16),
                                            AracTipi: response.body.data[i].RCR_Kategori,
                                            Arac: response.body.data[i].RCR_Arac,
                                            PNR: response.body.data[i].PNR_No
                                        })
                                    }
                                } else if (response.body.data[i].SaticiTip == 9) {
                                    this.coperGemi = true
                                    var Tarih = ""
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        Tarih = response.body.data[i].EndDate
                                    } else {
                                        Tarih = response.body.data[i].StartDate
                                    }
                                    this.coperGemiList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: Tarih,
                                        Konum: response.body.data[i].Otel_Konum,
                                        OdaTipi: response.body.data[i].Otel_OdaTipi,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 14) {
                                    this.coperSigorta = true
                                    this.coperSigortaList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        BasTarih: response.body.data[i].StartDate,
                                        BitTarih: response.body.data[i].EndDate,
                                        PNR: response.body.data[i].PNR_No
                                    })
                                } else if (response.body.data[i].SaticiTip == 11) {
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        this.coperVizeCikis = true
                                        this.coperVizeCikisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].Vize_RandevuZamani,
                                            VizeTip: response.body.data[i].Vize_Tip,
                                            PNR: response.body.data[i].PNR_No
                                        })
                                    } else {
                                        this.coperVizeGiris = true
                                        this.coperVizeGirisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].Vize_RandevuZamani,
                                            TeslimYeri: response.body.data[i].Vize_Tip,
                                            PNR: response.body.data[i].PNR_No
                                        })
                                    }
                                } else {
                                    this.coperAll = true
                                    this.coperAllList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        PNR: response.body.data[i].PNR_No
                                    })

                                }
                            }
                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                        }
                    },
                    response => {
                        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                        this.snackbar = true
                    }
                );

            }
        },
        handleEvents(events) {},
        getEventsCoper: getEventsCoper,
        getEventsTicket: getEventsTicket,
        getEventSearch: getEventSearch,
        git: git,
        gitcoper: gitcoper
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        timeformat: function (t) {
            return helpers.getTime(t)
        }
    }

}

function gitcoper(item) {
    var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + item.PNR;
    window.open(url, "_target");
}

function git(item) {
    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + item.HavayoluKodu + '&biletno=' + item.BiletNo + '&ucustipi=' + item.UcusTipi
    window.open(url, '_blank')
}

function getEventSearch() {
    var startDate = this.CalendarInput.StartDate
    var endDate = this.CalendarInput.EndDate

    var GetDate = new Date(startDate);
    let calendarApi = this.$refs.fullCalendar.getApi();
    calendarApi.gotoDate(GetDate);

    this.getEventsCoper(startDate, endDate)
    this.getEventsTicket(startDate, endDate)

}

function getEventsCoper(startDate, endDate) {
    this.calendarEvents = []
    this.calendarOptions.events = this.calendarEvents
    let params = {
        "Tarih1": startDate,
        "Tarih2": endDate,
        "SaticiTip": {
            Otel: true,
            Arac: true,
            Restaurant: true,
            Acente: true,
            RentACar: true,
            Rehber: true,
            Muze: true,
            Charter: true,
            Gemi: true,
            Diger: true,
            Feribot: true,
            Golf: true,
            Vize: true

        },
        "CikisSaticiTip": {
            Otel: true,
            RentACar: true,
            Gemi: true,
            Vize: true,
            Sigorta: true
        }
    }
    tool.http_post(this, 'NextCalendarCount', params).then(
        response => {
            if (response.body.Status == true) {
                for (var i = 0; i < response.body.data.length; i++) {
                    var islemAd = ""
                    if (response.body.data[i].SaticiTip == 1) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = this.$t('Hotel') + " Check In"
                        } else {
                            islemAd = this.$t('Hotel') + " Check Out"
                        }

                    } else if (response.body.data[i].SaticiTip == 2) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = this.$t('Vehicle') + " Check In"
                        } else {
                            islemAd = this.$t('Vehicle') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 3) {
                        islemAd = "Restaurant"
                    } else if (response.body.data[i].SaticiTip == 4) {
                        islemAd = this.$t('Agency')
                    } else if (response.body.data[i].SaticiTip == 5) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = "RentACar Check In"
                        } else {
                            islemAd = "RentACar Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 6) {
                        islemAd = "Rehber"
                    } else if (response.body.data[i].SaticiTip == 7) {
                        if (!response.body.data[i].Cikis) {
                            islemAd =this.$t('Museum') + " Check In"
                        } else {
                            islemAd = this.$t('Museum') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 8) {
                        islemAd = "Charter"
                    } else if (response.body.data[i].SaticiTip == 9) {
                        if (!response.body.data[i].Cikis) {
                            islemAd =this.$t('Cruise') + " Check In"
                        } else {
                            islemAd = this.$t('Cruise') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 10) {
                        islemAd =this.$t('Other')
                    } else if (response.body.data[i].SaticiTip == 11) {
                        if (!response.body.data[i].VizeRandevu) {
                            if (!response.body.data[i].Cikis) {
                                islemAd = this.$t('Visa-Check-In')
                            } else {
                                islemAd = this.$t('Visa-Check-Out')
                            }
                        } else {
                            islemAd = this.$t('Visa-Appointment-Day')
                        }

                    } else if (response.body.data[i].SaticiTip == 12) {
                        islemAd = this.$t('Tour-Operator')
                    } else if (response.body.data[i].SaticiTip == 13) {
                        islemAd = this.$t('Consulate')
                    } else if (response.body.data[i].SaticiTip == 14) {
                        islemAd = this.$t('Insurance')
                    } else if (response.body.data[i].SaticiTip == 15) {
                        islemAd = this.$t('Ferry')
                    } else if (response.body.data[i].SaticiTip == 16) {
                        islemAd = "Golf"
                    }

                    this.calendarEvents.push({
                        title: response.body.data[i].Toplam + " " + islemAd,
                        start: response.body.data[i].Tarih,
                        end: response.body.data[i].Tarih,
                        color: 'purple',
                        Provider: 'coper',
                        SalesType: response.body.data[i].SaticiTip,
                        Tarih: response.body.data[i].Tarih,
                        Cikis: response.body.data[i].Cikis,
                        VizeRandevu: response.body.data[i].VizeRandevu,
                        TurBulusma: response.body.data[i].TurBulusma
                    })
                }
                this.calendarOptions.events = this.calendarEvents

            } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
            }
        },
        response => {
            this.text1 = this.$t('An-error-has-occurred-Please-try-again')
            this.snackbar = true
        }
    );

}

function getEventsTicket(startDate, endDate) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu,
        StartDate: startDate,
        EndDate: endDate
    }

    this.$http.post(auth.API_URL + 'api/TicketReport/FlightCountCalenderList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        for (var i = 0; i < response.body.length; i++) {

            var title = response.body[i].UcusSayisi + this.$t('Number-Of-Flights')

            this.calendarEvents.push({
                title: title,
                start: response.body[i].UcusTarihi,
                end: response.body[i].UcusTarihi,
                color: 'green',
                Provider: 'ticket',
                Tarih: response.body[i].UcusTarihi
            })
        }
        this.calendarOptions.events = this.calendarEvents
    }, (response) => {
        if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function beforeMount() {

    this.calendarLocale= "en";
    console.log(this.calendarLocale);
    var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var endyyyy = date.getFullYear();

    if (mmend >= 12) {
        mmend = (Number(mm) + 1) - 12;
        endyyyy = Number(endyyyy) + 1;
    } else {
        mmend = Number(mmend) + 1
    }
    if (Number(mmend) < 9) {
        mmend = '0' + mmend
    }
    var start = yyyy + '-' + mm + '-' + '01'
    var end = endyyyy + '-' + mmend + '-' + '01'

    this.getEventsCoper(start, end)
    this.getEventsTicket(start, end)

}
</script>

<style scoped>
h2 {
    margin: 0;
    font-size: 16px;
    color: darkgreen;

}

ul {
    margin: 0;
    padding: 0 0 0 1.5em;
    color: darkgreen;

}

li {
    margin: 1.5em 0;
    padding: 0;
    color: darkgreen;
}

b {
    /* used for event dates/times */
    margin-right: 3px;
    color: darkgreen;

}

.demo-app {
    min-height: 100%;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
}

.demo-app-main {
    flex-grow: 1;
    padding: 3em;
}
</style>
